var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.33 521.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin logo icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M695.53,695.54H618.29v-121c0-28.85-.52-66-40.18-66-40.23,0-46.39,31.43-46.39,63.88V695.53H454.48V446.77h74.15v34h1a81.27,81.27,0,0,1,73.17-40.18c78.29,0,92.73,51.5,92.73,118.49ZM367.32,412.76a44.83,44.83,0,1,1,44.82-44.83,44.83,44.83,0,0,1-44.82,44.83h0m38.62,282.77H328.62V446.77h77.33ZM734,251.38H289.8A38,38,0,0,0,251.34,289V735a38.07,38.07,0,0,0,38.47,37.62H734A38.15,38.15,0,0,0,772.66,735V288.92A38.12,38.12,0,0,0,734,251.35",
    transform: "translate(-251.34 -251.34)",
    style: {
      fill: "#0a66c2"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.eb11e5e75854e5df0752812bbcabab63.svg";
export { ForwardRef as ReactComponent };